// extracted by mini-css-extract-plugin
module.exports = {"sso-login-header":"SocialRegistration_sso-login-header__7UTiP","container":"SocialRegistration_container__XciWb"};